"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
// external
const React = require("react");
const standardSizes_1 = require("../../../../types/standardSizes");
// css
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "Avatar");
/**
 * Displays a system avatar.
 */
const Avatar = ({ src, label = "", direction, stdSize = standardSizes_1.TStandardSizes.Medium }) => (React.createElement("div", { className: css("", `${direction}`) },
    React.createElement("div", { style: { backgroundImage: `url(${src})` }, className: css("image", {
            [`-stdSize-${stdSize}`]: !!stdSize,
            [`-${direction}`]: !!direction
        }), "data-test": "image" }),
    !!label && (React.createElement("span", { className: css("label", {
            [`-stdSize-${stdSize}`]: !!stdSize
        }) }, label))));
exports.Avatar = Avatar;
exports.default = exports.Avatar; // TODO: remove me (some components still import me the legacy way)
//# sourceMappingURL=index.js.map